﻿import { FIQAssist  } from "../app";
import { Component, Input, Output, Attribute, Inject } from "@fiqas/angular-utils";

@Component({
    module: FIQAssist,
    selector: 'roomdivider',
    transclude: true,
    template: `<div class="roomdivider">
               </div>`
})
export class RoomDivider {

    private _element: angular.IRootElementService;
    private _transclude: angular.ITranscludeFunction;
    private _initialized: boolean = true;

    constructor(
        @Inject('$element') private $element: angular.IRootElementService,
        @Inject('$transclude') $transclude: angular.ITranscludeFunction
    ) {
        this._element = $element;
        this._transclude = $transclude;
        this.initTransclude(this._transclude, this._element);
    }

    @Input() maxperctop: number;
    @Input() maxpercbottom: number;

    initTransclude(transclude: angular.ITranscludeFunction, element: angular.IRootElementService) {
        var index = 1;
        transclude((e, s) => {
            angular.forEach(e, x => {
                if (x.nodeType === 1) {
                    var divEl = document.createElement("div");
                    divEl.classList.add("division");
                    divEl.classList.add("division-" + index++);
                    angular.element(divEl).append(x);
                    element.children().append(divEl);
                }
            });
        });
    }

    public $onInit() {
        this._initialized = true;

//        this.resize();
    }

    resize() {
        if (this.maxperctop && this.maxpercbottom) {
            var container = this.$element.children()[0];
            var total = container.clientHeight;
            var maxheight1 = this.maxperctop * total / 100;
            var maxheight2 = this.maxpercbottom * total / 100;

            var el1 = this.$element.children().children()[0];
            var el2 = this.$element.children().children()[1];

            el1.style.maxHeight = maxheight1 + "px";
            el2.style.maxHeight = maxheight2 + "px";
        }
    }

}
